import { useCallback } from "react";
import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana35Div3M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandById = (id) => {
    return lands.filter((l) => l.id === id)[0];
  };
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };
  const getFill = useCallback(
    (id, selected2) => {
      const land = lands.find((l) => l.id === id);
      const disabledColor = "#6F8789";
      const normalColor = "#0096B3";
      const selectedColor = "#5AE5F4";

      if (!land) {
        return disabledColor; // disabled
      }

      if (selected) {
        if (id === selected.id) {
          return selectedColor;
        }
      }

      if (land.status !== "on_sale") {
        return disabledColor; // disabled
      } else {
        return normalColor; // normal color
      }
    },
    [lands, selected]
  );

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1468_43683)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("36"))}
        d="M812.098 519.296L799.085 437.315L745.732 450.328L765.252 528.406L812.098 519.296Z"
        fill={getFillByLot(36, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("35"))}
        d="M714.494 540.117L765.244 528.406L745.725 450.328L696.275 462.04L714.494 540.117Z"
        fill={getFillByLot(35, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("34"))}
        d="M663.753 553.131L714.504 540.118L696.286 462.04L645.535 473.752L663.753 553.131Z"
        fill={getFillByLot(34, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("33"))}
        d="M614.302 564.839L663.751 553.127L645.533 473.749L596.084 485.46L614.302 564.839Z"
        fill={getFillByLot(33, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("32"))}
        d="M563.548 576.552L614.299 564.84L596.081 485.461L545.33 495.872L563.548 576.552Z"
        fill={getFillByLot(32, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("31"))}
        d="M514.101 588.262L563.55 576.55L545.332 495.87L495.883 507.582L514.101 588.262Z"
        fill={getFillByLot(31, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("30"))}
        d="M463.358 599.975L514.109 588.264L495.891 507.583L446.441 519.295L463.358 599.975Z"
        fill={getFillByLot(30, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("29"))}
        d="M417.8 614.293L463.345 599.978L446.429 519.298L407.39 528.407L399.582 611.69L417.8 614.293Z"
        fill={getFillByLot(29, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("28"))}
        d="M343.631 597.376L399.587 611.69L407.394 528.407L364.452 519.298L343.631 597.376Z"
        fill={getFillByLot(28, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("27"))}
        d="M294.182 584.359L343.631 597.372L364.452 519.295L315.002 503.679L294.182 584.359Z"
        fill={getFillByLot(27, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("26"))}
        d="M244.74 571.346L294.189 584.358L315.01 503.678L265.561 491.967L244.74 571.346Z"
        fill={getFillByLot(26, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("25"))}
        d="M195.283 557.033L244.732 571.347L265.553 491.968L214.803 481.558L195.283 557.033Z"
        fill={getFillByLot(25, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("24"))}
        d="M177.066 553.133L195.284 557.037L214.803 481.562L144.533 464.645L170.559 560.941L177.066 553.133Z"
        fill={getFillByLot(24, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1468_43683"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1468_43683"
            transform="matrix(0.00178493 0 0 0.00236584 -2.39575 -0.327953)"
          />
        </pattern>
        <image
          id="image0_1468_43683"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
